import { render, staticRenderFns } from "./PrescriptionsDetails.vue?vue&type=template&id=7d7f9358&scoped=true"
import script from "./PrescriptionsDetails.vue?vue&type=script&lang=js"
export * from "./PrescriptionsDetails.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionsDetails.vue?vue&type=style&index=0&id=7d7f9358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f9358",
  null
  
)

export default component.exports